import type { IRainAgentConfig } from '../hooks/scope';

import { EArachneTool } from './arachne';

/**
 * Behavioral config for Arachne's chat, consumed by the Rain core hook via the
 * thread adapter.
 *
 * Unlike Sherlock — where the evidence trail *is* the product and every tool
 * call is surfaced — this drives a 360px hover overlay showing two plain
 * bubbles. Arachne's traversal is means, not output, so nothing renders as a
 * card and she is the one profile with an empty visible-tool set.
 *
 * `internalTools` lists that same set: it tells `useRainThreadMessages`' drift
 * reporter that dropping these is intentional, so a surface designed to show no
 * tools doesn't log a warning per call.
 */
export const ARACHNE_AGENT_CONFIG: IRainAgentConfig = {
  isVisibleTool: () => false,
  internalTools: new Set<string>(Object.values(EArachneTool)),
};
